import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class DigitalLectureSpeaker extends BaseModel {
  static override constructorName = 'DigitalLectureSpeaker'

  id: number = 0
  name: string = ''
  'middle_name': string = ''
  'last_name': string = ''
  'full_name': string = ''
  position: string = ''
  photo: string = ''
  url: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.photo = toCroppedImage(this.photo)
    }
  }
}

registerModel(DigitalLectureSpeaker)
